import { Component } from "@angular/core";
import { useTranslationNamespace } from "@logex/framework/lg-localization";

@Component({
    selector: "app-docusign-canceled",
    templateUrl: "./docusign-canceled.component.html",
    providers: [useTranslationNamespace("APP._Docusign.Canceled")]
})
export class DocusignCanceledComponent {}
